import { AspectRatio } from "@/constants/media";
import { ColorVariant, GradientVariant } from "@/constants/theme";

export enum TextAlignmentClassName {
  Left = "text-left",
  Center = "text-center",
  Right = "text-right",
  Justify = "text-justify",
}

export enum FlexPositionClassName {
  Left = "flex-start",
  Center = "flex-center",
  Right = "flex-end",
  Stretch = "flex-stretch",
  Top = "flex-top",
  Middle = "flex-middle",
  Bottom = "flex-bottom",
  Around = "flex-around",
  Between = "flex-between",
  Evenly = "flex-evenly",
  RowReverse = "flex-row-reverse",
}

export const AspectRatioClassName: Readonly<Record<AspectRatio, string>> = {
  [AspectRatio.Auto]: "ar-auto",
  [AspectRatio["1:1"]]: "ar-1x1",
  [AspectRatio["2:1"]]: "ar-2x1",
  [AspectRatio["4:3"]]: "ar-4x3",
  [AspectRatio["16:9"]]: "ar-16x9",
  [AspectRatio["16:10"]]: "ar-16x10",
  [AspectRatio["21:9"]]: "ar-21x9",
};

export const TextColorClassName: Readonly<Record<ColorVariant, string>> = {
  [ColorVariant.Default]: "",
  [ColorVariant.Inherit]: "c-inherit",
  [ColorVariant.Disabled]: "c-disabled",
  [ColorVariant.Black]: "c-black",
  [ColorVariant.White]: "c-white",
  [ColorVariant.Primary]: "c-brand-primary",
  [ColorVariant.Secondary]: "c-brand-secondary",
  [ColorVariant.Accent]: "c-brand-accent",
  [ColorVariant.BrandContrast]: "c-brand-contrast",
  [ColorVariant.Main]: "c-standard-main",
  [ColorVariant.Dark]: "c-standard-dark",
  [ColorVariant.Light]: "c-standard-light",
  [ColorVariant.StandardContrast]: "c-standard-contrast",
  [ColorVariant.Success]: "c-alert-success",
  [ColorVariant.Warning]: "c-alert-warning",
  [ColorVariant.Error]: "c-alert-error",
  [ColorVariant.Info]: "c-alert-info",
  [ColorVariant.Custom1]: "c-custom-color-1",
  [ColorVariant.Custom2]: "c-custom-color-2",
  [ColorVariant.Custom3]: "c-custom-color-3",
  [ColorVariant.Custom4]: "c-custom-color-4",
};

export const BackgroundColorClassName: Readonly<Record<ColorVariant, string>> =
  {
    [ColorVariant.Default]: "",
    [ColorVariant.Inherit]: "",
    [ColorVariant.Disabled]: "bg-disabled",
    [ColorVariant.Black]: "bg-black",
    [ColorVariant.White]: "bg-white",
    [ColorVariant.Primary]: "bg-brand-primary",
    [ColorVariant.Secondary]: "bg-brand-secondary",
    [ColorVariant.Accent]: "bg-brand-accent",
    [ColorVariant.BrandContrast]: "bg-brand-contrast",
    [ColorVariant.Main]: "bg-standard-main",
    [ColorVariant.Dark]: "bg-standard-dark",
    [ColorVariant.Light]: "bg-standard-light",
    [ColorVariant.StandardContrast]: "bg-standard-contrast",
    [ColorVariant.Success]: "bg-alert-success",
    [ColorVariant.Warning]: "bg-alert-warning",
    [ColorVariant.Error]: "bg-alert-error",
    [ColorVariant.Info]: "bg-alert-info",
    [ColorVariant.Custom1]: "bg-custom-color-1",
    [ColorVariant.Custom2]: "bg-custom-color-2",
    [ColorVariant.Custom3]: "bg-custom-color-3",
    [ColorVariant.Custom4]: "bg-custom-color-4",
  };

export const BackgroundGradientClassName: Readonly<
  Record<GradientVariant, string>
> = {
  [GradientVariant.Default]: "",
  [GradientVariant.Gradient1]: "bgr-1",
  [GradientVariant.Gradient2]: "bgr-2",
  [GradientVariant.Gradient3]: "bgr-3",
  [GradientVariant.Gradient4]: "bgr-4",
};

export enum GridBreakpoint {
  xs = 0,
  sm = 576,
  md = 768,
  lg = 992,
  xl = 1200,
  xxl = 1400,
}
